/*eslint-disable*/
import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  Link,
  Typography,
  Dialog,
} from '@material-ui/core';
import {
  LoginAmplify,
  LoginAuth0,
  LoginFirebase,
  LoginJWT,
} from '../../components/authentication/login';
import Logo from '../../components/Logo-Login';
import useAuth from '../../hooks/useAuth';
import gtm from '../../lib/gtm';
import VerifyEmail from './VerifyEmail';
import { useStyles } from './style';

const Login: FC = () => {
  const { platform } = useAuth() as any;
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation('account');

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{`${t('login.login')} | Prior`}</title>
      </Helmet>
      <Box className={classes.bg}>
        <Container maxWidth="sm" sx={{ py: '80px' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <RouterLink
              onClick={() =>
                window.location.replace('/')
              }
              to={''}
            >
              <Logo
                sx={{
                  height: 225,
                  width: 400
                }}
              />
            </RouterLink>
          </Box>
          <Card>
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 4,
              }}
            >
              <Box
                sx={{
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: 1,
                }}
              >
                <div>
                  <Typography
                    color="textSecondary"
                    className={classes.title}
                    gutterBottom
                    variant="h4"
                  >
                    {t('login.title')}
                  </Typography>
                </div>
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  mt: 3,
                }}
              >
                {platform === 'Amplify' && <LoginAmplify />}
                {platform === 'Auth0' && <LoginAuth0 />}
                {platform === 'Firebase' && <LoginFirebase />}
                {platform === 'JWT' && <LoginJWT />}
              </Box>
              <Divider sx={{ my: 3 }} />
              <Box display="flex">
                <Link
                  className={classes.textLink}
                  component={RouterLink}
                  onClick={handleOpen}
                  to="/authentication/register"
                  variant="body2"
                >
                  Crear Cuenta
                </Link>
                <Box flexGrow={1} />
                <Link
                  className={classes.textLink}
                  component="button"
                  onClick={handleOpen}
                  /* to="/authentication/password-recovery" */
                  variant="body2"
                >
                  {t('login.forgotPassword')}
                </Link>
              </Box>
            </CardContent>
          </Card>
        </Container>
        <Dialog open={open} onClose={handleClose}>
          <VerifyEmail handleClose={handleClose} />
        </Dialog>
      </Box>
    </>
  );
};

export default Login;
